
<template>
  <div>
    <main class="main">
      <RemindText />
      <div class="container client_container">
        <div class="clients_course">
          <div class="course_photo">
            <img v-bind:src="imgCover" class="course_img">
          </div>
          <div class="course_info">
            <h1 class="course_info_title">{{this.title}}</h1>
            <p class="course_info_subtitle">{{this.subtitle}}</p>
            <div class="course_info_author">
              <div class="author_img"><img v-bind:src="author_imgAvatar" ></div>
              <div class="author_name">{{this.author_title}}</div>
            </div>
            <div class="course_info_group">
              <div class="course_info_totel">
                <div class="total">
                  <div class="itotal_text">
                    {{ total }} 集
                    <span v-show="courseTotalCopy !== 99999">/</span>
                  </div>
                  <div v-show="courseTotalCopy !== 99999" class="text-main total_text">
                    可借聽數 {{ courseTotalCopy }}
                  </div>
                </div>
                <div v-show="!isAppUserAgent" class="appOpen_btn">
                  <a v-bind:href="clientsQRCode" class="appOpen_link mobile_btn"><span class="appOpen_btn_icon"><img src="@/assets/images/clients/icon_mobilenew_white.svg" alt="在App借聽"></span>在 App 借聽</a>
                  <div class="appOpen_link pc_btn" @click="openModel">在 App 借聽</div>
                </div>
              </div>
              <div class="course_info_share">
                <ShareNetwork
                  network="facebook"
                  :url= pageUrl
                  title=""
                  description=""
                  quote=""
                  hashtags=""
                  tag="div"
                  class="fb share_item"
                >
                  <div class="share_icon"><img src="@/assets/images/icon_share_fb.png" alt="分享"></div>
                  <a href="javascript:void(0)" class="share_link">分享</a>
                </ShareNetwork>

                <ShareNetwork
                  network="line"
                  :url= pageUrl
                  title=""
                  description=""
                  quote=""
                  hashtags=""
                  tag="div"
                  class="line share_item"
                >
                  <div class="share_icon"><img src="@/assets/images/icon_share_line.png" alt="分享"></div>
                  <a href="javascript:void(0)" class="share_link">分享</a>
                </ShareNetwork>

              </div>
            </div>

          </div>
        </div>
        <div class="bodyContent bodyCourse">
          <div v-if="publisher!=null" class="publisher"><p v-html="publisher"></p></div>
          <section class="uploadArea intro">
            <h2>課程簡介</h2>
            <span v-html="description"></span>
          </section>
          <section class="demo" v-show="checkAuditionVideosList">
            <h2>試聽內容</h2>
            <ul>
              <li v-for = "audition_videos in audition_videos_list" :key="audition_videos.id">

                <p v-if="isMobile"><a data-fancybox target="_blank" v-bind:href="youtube_url+ audition_videos.video" class="playBtn">播放</a></p>

                <p v-if="!isMobile"><a data-fancybox v-bind:href="youtube_url+ audition_videos.video" class="playBtn glightbox3">播放</a></p>

                <p>{{audition_videos.title}}</p>
              </li>
            </ul>
          </section>

          <section class="uploadArea">
            <!-- <h2>分集大綱</h2> -->
            <div>
              <span v-html="descriptionHtml"></span>
            </div>
          </section>
        </div>
        <ClientsQRcode/>
      </div>
    </main>

    <transition name='fade'>
      <div class="caption_modal" v-show="openQrcodeCaption">
        <div class="caption_wrap">
          <div class="caption_group">
            <div class="caption_close">
              <button type="button" class="close_btn" @click="closeCaption">
                <img src="@/assets/images/btn_close.png" class="close_icon" alt="close_icon">
              </button>
            </div>
            <div class="caption_qrcode">
              <img src="@/assets/images/clients/qrcode_decofocus.svg" alt="" class="qrcode_bg">
              <qrcode-vue :value="clientsQRCode" :size="210" level="H"></qrcode-vue>
            </div>
            <div class="caption_text">
              <p>掃描下載一刻鯨選 App</p>
              <p>享受完整聆聽服務</p>
            </div>
          </div>
        </div>

        <div class='client_overlay' @click="closeCaption"></div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import fancybox from '@/assets/vendor/fancybox-master/jquery.fancybox.min.js'

// eslint-disable-next-line no-unused-vars
import readmore from '@/assets/vendor/readmore/readmore.min.js'
// eslint-disable-next-line no-unused-vars
import functionJs from '@/assets/js/function.js'
// eslint-disable-next-line no-unused-vars
import pace from '@/assets/vendor/pace/js/pace.min.js'

// let glightbox = require('@/assets/vendor/glightbox-master/glightbox.min.js')
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import RemindText from '../components/RemindText'
import ClientsQRcode from '../components/ClientsQRcode'

export default {
  name: 'ClientsCourse',
  metaInfo () {
    return {

      title: `${this.title} | ${this.clientTitle} | 一刻鯨選`,
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: `${this.title} | ${this.clientTitle} | 一刻鯨選` },
        { property: 'og:site_name', content: `${this.title} | ${this.clientTitle} | 一刻鯨選` },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.imgCover },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: this.meta_description }

      ]
    }
  },
  components: {
    ClientsQRcode,
    RemindText,
    QrcodeVue
  },
  computed: {
    ...mapGetters([
      'clientsQRCode',
      'clientsCID',
      'clientTitle',
      'clientAssets',
      'clientCourses'
    ]),
    // eslint-disable-next-line vue/return-in-computed-property
    courseTotalCopy () {
      for (let i = 0; i < this.clientAssets.length; i++) {
        if (this.clientAssets[i].channel.id === this.channelID) {
          return this.clientAssets[i].total_copy
        }
      }
    }

  },
  data () {
    return {
      classData: [],
      channelID: '',
      title: '', // 標題
      subtitle: '', // 副標題
      imgCover: '', // 圖片
      meta_description: '', // 描述(meta用)
      description: '',
      descriptionHtml: '', // 描述HTML
      target: '', // 適合對象
      total: '', // 總課堂數
      total_copy: null, // 可借聽數
      author: [], // 作者
      author_title: '', // 作者標題
      author_imgAvatar: '', // 作者圖片
      author_description: '', // 作者描述
      episodes_title: '', // 音頻標題
      episodes_summary: '', // 音頻大綱
      audition_videos_list: [], // 試聽影音
      publisher: '', // 出版方
      youtube_url: 'https://www.youtube.com/watch?v=',
      id: '0',
      shareURL: '',
      checkAuditionVideosList: true,
      pageUrl: '',
      lineShareValue: '',
      isMobile: false,
      isAppUserAgent: false,
      openQrcodeCaption: false

    }
  },
  created () {
    var userAgent = navigator.userAgent
    // console.log(userAgent)
    // console.log(userAgent.indexOf('jinfmapp') > -1)
    if (userAgent.indexOf('jinfmapp') > -1) {
      this.isAppUserAgent = true
    }

    this.pageUrl = window.location.toString()
    if (this.pageUrl.includes('?')) {
      this.pageUrl = this.pageUrl.split('?')[0]
    }

    this.shareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.toString()

    const pathName = window.location.pathname
    var index = window.location.pathname.lastIndexOf('/')

    this.channelID = Number(pathName.substring(index + 1, pathName.length))
    // console.log(this.channelID)

    this.checkClientCourse()
    // console.log(this.clientCourses.indexOf(this.channelID) !== -1)
  },
  mounted () {
    this.setQRCode(this.clientsCID, this.channelID)
  },
  updated () {
    //      //判斷是否手機
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isiOS === true || isAndroid === true) {
      this.isMobile = true
    }

    if (window.scrollY > 0) {
      $('html,body').animate({
        scrollTop: 0
      }, 'slow')
    }

    $('#pagetop p').click(function () {
      $('html,body').animate({ scrollTop: 0 }, 'slow')
      return false
    })
  },
  methods: {
    strip_html_tags (str) {
      if ((str === null) || (str === '')) { return false } else { str = str.toString() }
      return str.replace(/<[^>]*>/g, '')
    },
    checkClientCourse () {
      console.log(this.clientCourses)
      if (this.clientCourses.length === 0) {
        this.axios
          .get(`${this.$store.getters.baseURL}clients/${this.clientsCID}`)
          .then(response => {
          // eslint-disable-next-line eqeqeq
            if (response.status == 200) {
              const clientAssets = response.data.client_blocks[0].client_assets

              const coursesIdList = clientAssets.map((clientAsset) => {
                return clientAsset.channel.id
              })
              console.log(coursesIdList)

              coursesIdList.indexOf(this.channelID) !== -1 ? this.getClientCourse(this.channelID) : this.backClientIndex(this.clientsCID)
            } else if (response.includes('404')) {
              this.$router.push(`/org/${cid}`)
            }
          })
          .catch(error => console.log('log:' + error))
      } else {
        this.clientCourses.indexOf(this.channelID) !== -1 ? this.getClientCourse(this.channelID) : this.backClientIndex(this.clientsCID)
      }
    },
    getClientCourse (id) {
      this.axios
        .get(this.$store.getters.baseURL + 'channels/' + id)
        .then(response => {
          this.classData = response.data
          this.imgCover = this.classData.imgCover
          this.total = this.classData.total
          this.author = this.classData.author
          this.author_imgAvatar = this.author.imgAvatar
          this.audition_videos_list = this.classData.audition_videos

          if (this.audition_videos_list.length === 0) {
            this.checkAuditionVideosList = false
          }
          this.getTW()
          this.meta_description = this.strip_html_tags(this.meta_description)
          this.lineShareValue = '【一刻鯨選】' + this.title + '\n' + ''

          if (this.title !== '') {
            this.getClientTitle()
          }
        })
        .catch(error => console.log('log:' + error))
    },
    getTW () {
      this.title = this.classData.title
      this.subtitle = this.classData.subtitle
      this.description = this.classData.description
      this.meta_description = this.classData.description
      this.descriptionHtml = this.classData.descriptionHtml
      this.target = this.classData.target
      this.author_title = this.author.title
      this.author_description = this.author.descriptionHtml
      this.publisher = this.classData.publisher
    },
    getClientTitle () {
      this.axios
        .get(`${this.$store.getters.baseURL}clients/${this.clientsCID}`)
        .then(response => {
          const clientName = response.data.display_name
          this.gaPage(clientName)
        })
        .catch(error => console.log('log:' + error))
    },
    setQRCode (id, channelID) {
      const pageUrl = `${window.location.origin}/org/${id}/${channelID}`
      const QRCodeValue = `https://jinfm.page.link/?link=${pageUrl}&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm`
      this.$store.commit('CLIENTS_QRCODE', QRCodeValue)
    },
    gaPage (name) {
      // ga
      this.$ga.page({
        page: `/org/${this.clientsCID}/${this.channelID}`,
        title: `${this.title} | ${this.clientTitle} | 一刻鯨選`,
        location: window.location.href
      })
    },
    setYoutube (id) {
      this.youtube_url = this.youtube_url + id
    },
    // 切換Scroll效果
    stopScroll (val) {
      if (val) {
        this.$modalHelper.afterOpen()
      } else {
        this.$modalHelper.beforeClose()
      }
    },
    openModel () {
      this.openQrcodeCaption = true
      this.stopScroll(true)
    },
    closeCaption () {
      this.openQrcodeCaption = false
      this.stopScroll(false)
    },
    backClientIndex (cid) {
      this.$router.push(`/org/${cid}`)
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$modalHelper.beforeClose()
    next()
  }
}
</script>

<style lang="scss"  scoped>
@import "../../../../assets/scss/clients.scss";

.clients_course {
  margin-top: 25px;
  .course_img {
    border-radius: 10px;
    box-shadow: 0 0 15px hsla(0,0%,60%,.1);
  }
}

.bodyCourse {
  background: transparent;
}

@media screen and (min-width: 768px){
  .clients_course {
    display: flex;
    justify-content: space-between;
    > .course_photo {
      flex: 0 0 43%;
      max-width: 43%;
    }
    > .course_info {
      flex: 0 0 50%;
      max-width: 50%;
    }
    .course_info {
      margin-top: 0;
      display: flex;
      flex-direction: column;
      .course_info_title {
        margin-bottom: 16px;
      }
      .course_info_author {
        margin-bottom: 35px;
      }
      .course_info_group {
        display: flex;
        justify-content: space-between;
        margin-top: auto;
        .course_info_totel {
          margin-bottom: 0;
          flex: 1 1 auto;
          .total {
            font-size: 14px;
          }
        }
        .appOpen_btn {
          padding: 5px 8px;
          .pc_btn {
            display: flex;
          }
          .mobile_btn {
            display: none;
          }
        }
        .course_info_share {
          > *:not(:last-child) {
            margin-right: 0px;
            margin-left: 10px;
          }
          >>> .line {
            display: none;
          }
          >>> .fb {
            padding: 7px 8px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 997px){
  .clients_course {
    > .course_photo, .course_info {
      flex: 0 0 47%;
      max-width: 47%;
    }
  }
}
@media screen and (min-width: 1280px){
  .clients_course .course_info .course_info_group .course_info_totel .total {
    font-size: 18px;
  }
}

.course_info {
  margin-top: 20px;
  .course_info_title {
    text-align: left;
    font-size: 28px;
    line-height: 40px;
    color: #000;
  }
  .course_info_subtitle {
    font-size: 18px;
    line-height: 25px;
    opacity: 0.5;
    margin-bottom: 16px;
  }
  .course_info_author {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .author_img {
      width: 40px;
      margin-right: 16px;
      & img {
        border-radius: 50%;
      }
    }
    .author_name {
      font-size: 18px;
    }
  }
  .course_info_totel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    .total {
      display: flex;
      // font-size: 18px;
      line-height: 25px;
      font-weight: bold;
      > *:not(:last-child) {
        margin-right: 6px;
      }
    }
  }
  .appOpen_btn {
    background-color: rgb(5,155,173);
    border-radius: 4px;
    padding: 4px 12px;
    cursor: pointer;
    display: inline-block;
    .appOpen_link {
      color: white;
      text-decoration: none;
      font-size: 14px;
      border-radius: 4px;
      display: flex;
      align-items: center;
    }
    .pc_btn {
      display: none;
    }
    .mobile_btn {
      display: flex;
    }
    .appOpen_btn_icon {
      margin-right: 7px;
      & img {
        width: 12px;
      }
    }
  }
  .course_info_share {
    display: flex;
    > *:not(:last-child) {
      margin-right: 10px;
    }
    >>> .share_item {
      display: flex;
      align-items: center;
      padding: 5px 8px;
      border-radius: 4px;
      cursor: pointer;
    }
    >>> .share_icon {
      margin-right:3px;
      display: flex;
      align-items: center;
      & img {
        width: 16px;
      }
    }
    >>> .share_link {
      display: inline-block;
      font-size: 11px;
      color: white;
      position: relative;
      line-height: 16px;
      text-decoration: none;
    }
    >>> .fb {
      background: linear-gradient(180deg,#4a67bd 0,#3952a2);
    }
    >>> .line {
      background: linear-gradient(180deg,#6bdd00 0,#13b700);
    }
  }
}

//Caption_Modal

.caption_modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding-top: 0px;
  z-index: 1000;
}

.caption_close {
  text-align: right;
  .close_btn {
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    border: 0;
  }
  .close_icon {
    width: 20px;
  }
}

.caption_wrap {
  margin: auto;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background-color: #fff;
  overflow: hidden;
}

.caption_qrcode {
  position: relative;
  text-align: center;
  margin-top: 100px;
  .qrcode_bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.caption_text {
  text-align: center;
  margin-top: 50px;
  > * {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 0
  }
}

.caption_group {
  position: relative;
  z-index: 3;
  padding: 25px 35px 45px;
  height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 5px;
    height: 7px;
    padding-right: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgb(219, 220, 221);
    border: 0px none #ffffff;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  .client_description {
    >>> h2 {
      font-size: 24px;
      line-height: 33px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    >>> p {
      font-size: 16px;
      line-height: 26px;
      margin-bottom: 30px;
    }
  }
}

.client_overlay {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.65);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: -1;
}

.fade-enter-active {
  transition: opacity .8s
}

.fade-leave-active {
  transition: opacity .4s
}

.fade-enter,.fade-leave-to {
  opacity: 0;
}

.fadeIn_header{
  animation: fadeIn 1s;
}

/*頭像動畫*/
@-webkit-keyframes fadeIn{
  0% { opacity: 0 }
  50%{ opacity: 0.5 }
  100%{ opacity: 1}
}

@keyframes fadeIn{
  0% { opacity: 0 }
  50%{ opacity: 0.5 }
  100%{ opacity: 1}
}

@media screen and (min-width: 576px){
  .caption_modal {
    padding: 100px 0;
  }
  .caption_wrap {
    border-radius: 10px;
    width: 450px;
  }
  .caption_group {
    height: calc(100vh - 200px);
    padding: 25px 35px;
  }
}
//Caption_Modal END
</style>



// WEBPACK FOOTER //
// src/components/views/clients/ClientsCourse/index.vue